<script>
  import { onMount } from 'svelte'
  import Rating from '../../components/Rating.svelte'
  export let summary
  export let settings
  export let summaryType

  let reviewsText
  let starColor
  let reviewTitleText
  let basedOnText
  let questionsText
  let answersText

  onMount(() => {
    reviewsText = settings.translations.reviews_text
    starColor = settings.widget_settings.general_settings.star_rating_color
    reviewTitleText = settings.translations.neptune.review_title_text
    basedOnText = settings.translations.based_on_text
    questionsText = settings.translations.questions_text
    answersText = settings.translations.answers_text
  })
</script>

<style>
  :global(._3SjZ6) {
    display: flex;
    flex-direction: column;
  }

  :global(._3pMn0) {
    font-size: 18px;
    position: absolute;
    top: 19px;
    color: #000000;
  }

  :global(._2qBv6) {
    display: flex;
    margin-top: 5px;
    color: #000000;
  }

  :global(._3vEzv) {
    font-weight: 300;
    margin-right: 5px;
  }

  :global(._1AOwn) {
    font-weight: 400;
  }

  #body {
    display: flex;
    align-items: center;
  }

  #body > * {
    margin-right: 5px;
  }

  #body p {
    font-size: 18px;
    margin: 0;
    margin-right: 14px;
    padding-bottom: 0;
    color: #000000;
  }
</style>

<div class="_3SjZ6">
  <div class="_3pMn0">{reviewTitleText}</div>
  {#if summary.count > 0}
    {#if summaryType === 'reviews'}
      <div id="body">
        <p>{summary.average}</p>
        <Rating reviewrating={summary.average} {starColor} />
      </div>
      <div class="_2qBv6">
        <span class="_3vEzv">{basedOnText}</span>
        <span class="_1AOwn">
          {summary.count} {reviewsText}
        </span>
      </div>
    {/if}
    {#if summaryType === 'questions'}
      <div class="_2qBv6">
        <p>
          {summary.count} {questionsText} \ {summary.answer_count} {answersText}
        </p>
      </div>
    {/if}
  {/if}
</div>
